export default __webpack_public_path__ + "f999b23d2808b3a9160629a435de9337.png";